/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import AlertButton from 'components/AlertButton';
import AlertForm from 'components/AlertForm';
import { Container, Box, Typography, Button } from '@mui/material';
import { SUBMIT_FORM } from 'constants/dinerSignupConstants';
import { calcRem } from 'utils';

// TODO https://getbentobox.atlassian.net/browse/DMD-2294 & https://getbentobox.atlassian.net/browse/DMD-2973

const DinerSignupAlertContainer = ({
  contentContext,
  successContentContext,
  formContext,
  buttonProps,
  successButtonProps
}) => {
  const [isSuccessState, setIsSuccessState] = useState(false);
  const context = isSuccessState ? successContentContext : contentContext;
  return (
    <Container width={calcRem(705)} data-popup-auto-open="modal">
      <Box
        sx={{
          background: 'white',
          margin: 0,
          padding: 0,
          height: calcRem(573),
          width: calcRem(705),
          display: 'flex'
        }}
      >
        {context.image && (
          <Box sx={{ backgroundColor: 'red', width: calcRem(312) }}>
            HERE IS AN IMAGE
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            padding: calcRem(29),
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <Typography variant="h3" align="center">
            {context.header}
          </Typography>
          <Typography align="center" sx={{ mb: calcRem(16) }}>
            {context.body}
          </Typography>
          {buttonProps.action === SUBMIT_FORM && (
            <AlertForm formContext={formContext} />
          )}

          <AlertButton
            handleClick={() => setIsSuccessState(true)}
            type="submit"
            buttonProps={isSuccessState ? successButtonProps : buttonProps}
          />
          <Button sx={{ borderRadius: 0 }}>NO THANKS</Button>
        </Box>
      </Box>
    </Container>
  );
};

DinerSignupAlertContainer.propTypes = {
  successContentContext: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  buttonProps: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string,
    button_type: PropTypes.string
  }).isRequired,
  successButtonProps: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string,
    button_type: PropTypes.string
  }),
  formContext: PropTypes.shape({
    alert_form_fields: PropTypes.shape({
      label: PropTypes.string
    })
  }),
  contentContext: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired
};

DinerSignupAlertContainer.defaultProps = {
  successContentContext: {},
  successButtonProps: {},
  formContext: {}
};

export default DinerSignupAlertContainer;
